// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2B6ag","Success":"Button_Success__w3P5K","Danger":"Button_Danger__1BArH","Gray":"Button_Gray__32sof"};